import type { ReactNode } from "react";
import { PlanGate, type RequiredPlan } from "./PlanGate";
import { usePlanFeatures } from "../../hooks/usePlanFeatures";
import { LoadingSpinner } from "./LoadingSpinner";

interface RequirePlanProps {
  requiredPlan: RequiredPlan;
  featureName: string;
  features: string[];
  children: ReactNode;
  fallback?: ReactNode;
}

export function RequirePlan({
  requiredPlan,
  featureName,
  features,
  children,
  fallback,
}: RequirePlanProps) {
  const { meets, isLoading } = usePlanFeatures();

  if (isLoading) {
    return (
      <div className="p-4">
        <LoadingSpinner />
      </div>
    );
  }

  if (!meets(requiredPlan)) {
    if (fallback !== undefined) return <>{fallback}</>;
    return (
      <div className="p-4">
        <PlanGate requiredPlan={requiredPlan} featureName={featureName} features={features} />
      </div>
    );
  }

  return <>{children}</>;
}
